import React, { useMemo } from 'react';
import { useLocation } from 'react-router';

import { parseLocationPath } from 'app/modules/Navigation/utils';
import ErrorBoundary from 'app/widgets/ErrorBoundary';
import NotFound from 'app/widgets/Errors/NotFound';

import { AllSportsGrid } from './AllSportsGrid';
import Announcement from './Announcement';
import MatchCenterLive from './MatchCenter';
import SportGrid from './SportGrid';
import { StageGrid } from './StageGrid';
import { StreamGrid } from './StreamGrid';

export const LiveContent = () => {
  const { pathname } = useLocation();
  const {
    list,
    sportId,
    tournamentStageId,
    matchId,
  } = useMemo(() => parseLocationPath(pathname), [pathname]);

  if (matchId) {
    return (
      <ErrorBoundary>
        <MatchCenterLive />
      </ErrorBoundary>
    );
  }

  if (tournamentStageId) {
    return (
      <ErrorBoundary>
        <StageGrid />
      </ErrorBoundary>
    );
  }

  if (sportId && !list) { // also handles `tournamentId`
    return (
      <ErrorBoundary>
        <SportGrid sportId={sportId} />
      </ErrorBoundary>
    );
  }

  switch (list) {
    case null:
      return (
        <ErrorBoundary>
          <AllSportsGrid />
        </ErrorBoundary>
      );

    case 'streams':
      return (
        <ErrorBoundary>
          <StreamGrid />
        </ErrorBoundary>
      );

    case 'announcement':
      return (
        <ErrorBoundary>
          <Announcement />
        </ErrorBoundary>
      );

    default:
      return <NotFound />;
  }
};
